import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/board/excel_ico.png'
import _imports_1 from '@/assets/sns/twitter_ico.png'
import _imports_2 from '@/assets/sns/google_ico.png'
import _imports_3 from '@/assets/sns/naver_ico.png'
import _imports_4 from '@/assets/sns/youtube_ico.png'
import _imports_5 from '@/assets/sns/instargram_ico.png'
import _imports_6 from '@/assets/sns/bluesky_ico.png'


const _withScopeId = n => (_pushScopeId("data-v-8e1de326"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { id: "board_layer" }
const _hoisted_6 = { class: "board_search_wrap" }
const _hoisted_7 = { class: "monitoring_menu" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "board_top" }
const _hoisted_10 = { class: "board_top_btns" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "엑셀다운로드", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "board_top_btns_right" }
const _hoisted_15 = { class: "count" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "70" }, "70", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1))
const _hoisted_20 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "board_list monitoring_list" }
const _hoisted_22 = { class: "board_cate_btns" }
const _hoisted_23 = {
  class: "board_action_btns monitoring_board",
  style: {"align-items":"center"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt_in_tit" }, "유형", -1))
const _hoisted_25 = { class: "mt_in_flex" }
const _hoisted_26 = ["value"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt_in_tit" }, "세부 유형", -1))
const _hoisted_28 = { class: "mt_in_flex" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "board_table monitoring_board" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { width: "3%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "6%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" })
], -1))
const _hoisted_32 = { class: "chk" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "연번", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "내용 및 검색정보", -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "" }
const _hoisted_38 = { class: "chk" }
const _hoisted_39 = ["value"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_41 = { class: "mt_con" }
const _hoisted_42 = { class: "mt_con_left" }
const _hoisted_43 = { class: "thumb_box" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["src"]
const _hoisted_46 = { type: "button" }
const _hoisted_47 = {
  key: 0,
  src: _imports_1
}
const _hoisted_48 = {
  key: 1,
  src: _imports_2
}
const _hoisted_49 = {
  key: 2,
  src: _imports_3
}
const _hoisted_50 = {
  key: 3,
  src: _imports_4
}
const _hoisted_51 = {
  key: 4,
  src: _imports_5
}
const _hoisted_52 = {
  key: 5,
  src: _imports_6
}
const _hoisted_53 = { class: "mt_con_list left" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "고유번호")
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "글쓴이(계정)", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "메신저ID", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "전화번호", -1))
const _hoisted_58 = { class: "mt_in" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "키워드", -1))
const _hoisted_60 = { class: "mt_con_list right" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "내용", -1))
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "해시태그", -1))
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "URL", -1))
const _hoisted_66 = { key: 0 }
const _hoisted_67 = ["href"]
const _hoisted_68 = { class: "mt_in_btns info_btn" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = {
  key: 0,
  class: "report_fail"
}
const _hoisted_72 = ["src"]
const _hoisted_73 = ["src"]
const _hoisted_74 = { class: "mt_con_right" }
const _hoisted_75 = { class: "mt_in_flex" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt_in_tit" }, "유형", -1))
const _hoisted_77 = ["onUpdate:modelValue", "onChange"]
const _hoisted_78 = ["value"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt_in_tit" }, "세부유형", -1))
const _hoisted_80 = { class: "mt_in_flex" }
const _hoisted_81 = { class: "mt_in_flex" }
const _hoisted_82 = ["onUpdate:modelValue"]
const _hoisted_83 = ["value"]
const _hoisted_84 = ["onUpdate:modelValue"]
const _hoisted_85 = { class: "mt_in_flex" }
const _hoisted_86 = { class: "mt_in_btns" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { colspan: "3" }
const _hoisted_90 = { key: 2 }
const _hoisted_91 = { colspan: "3" }
const _hoisted_92 = { class: "board_bottom" }
const _hoisted_93 = { class: "board_action_btns2" }
const _hoisted_94 = {
  class: "board_action_btns2 monitoring_board",
  style: {"align-items":"center"}
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt_in_tit" }, "유형", -1))
const _hoisted_96 = { class: "mt_in_flex" }
const _hoisted_97 = ["value"]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt_in_tit" }, "세부 유형", -1))
const _hoisted_99 = { class: "mt_in_flex" }
const _hoisted_100 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_NoResult = _resolveComponent("NoResult")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_ModalComponents = _resolveComponent("ModalComponents")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.tabMenu, (item, idx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        onClick: ($event: any) => ($setup.selectStatus(item.idx)),
                        class: _normalizeClass(item.idx === $setup.state.selectStatus ? 'active' : '')
                      }, [
                        _createElementVNode("p", null, _toDisplayString(item.label), 1),
                        _createElementVNode("p", null, _toDisplayString($setup.numberFormat($setup.state.statusCnt[item.key])), 1)
                      ], 10, _hoisted_8))
                    }), 256))
                  ])
                ]),
                _createVNode(_component_Filter, {
                  isMonitoring: false,
                  nation: false,
                  selectOption: $setup.state.selectOption,
                  onSearch: $setup.filterSearch,
                  onReset: $setup.resetSearch
                }, null, 8, ["selectOption", "onSearch", "onReset"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn delete",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.deleteCheckLists()))
                  }, "삭제"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn board_ico_btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.excelDownLoad && $setup.excelDownLoad(...args)))
                  }, _hoisted_13)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createTextVNode(" 총 "),
                    _createElementVNode("span", null, _toDisplayString($setup.numberFormat($setup.state.totalLength)) + "건", 1)
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    name: "",
                    id: "",
                    class: "select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.perPage) = $event))
                  }, _hoisted_20, 512), [
                    [
                      _vModelSelect,
                      $setup.state.perPage,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateCheckLists(2)))
                  }, "분석완료"),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.updateCheckLists(3)))
                  }, "삭제요청완료")
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn_blue",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.multiReport()))
                  }, "신고하기"),
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("select", {
                      class: "select",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.typeIdx) = $event)),
                      onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.state.detailIdx = $setup.getDetailTypeFilter($setup.state.typeIdx)[0].idx)),
                      style: {"padding-right":"40px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.typeList, (type) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: type.idx
                        }, _toDisplayString(type.name), 9, _hoisted_26))
                      }), 256))
                    ], 544), [
                      [
                        _vModelSelect,
                        $setup.state.typeIdx,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("select", {
                      class: "select",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.detailIdx) = $event)),
                      style: {"padding-right":"40px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getDetailTypeFilter($setup.state.typeIdx), (dType) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: dType.idx
                        }, _toDisplayString(dType.name), 9, _hoisted_29))
                      }), 256))
                    ], 512), [
                      [
                        _vModelSelect,
                        $setup.state.detailIdx,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.updateState()))
                  }, "유형 일괄변경")
                ]),
                _createElementVNode("table", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _createElementVNode("label", _hoisted_32, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.state.isAllCheck) = $event)),
                            onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.toggleAll && $setup.toggleAll(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, $setup.state.isAllCheck]
                          ]),
                          _hoisted_33
                        ])
                      ]),
                      _hoisted_34,
                      _hoisted_35
                    ])
                  ]),
                  (!$setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.data, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                            _createElementVNode("td", null, [
                              _createElementVNode("label", _hoisted_38, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.state.checkedList) = $event)),
                                  value: item.idx
                                }, null, 8, _hoisted_39), [
                                  [_vModelCheckbox, $setup.state.checkedList]
                                ]),
                                _hoisted_40
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.idx), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", {
                                      class: "thumb",
                                      onClick: ($event: any) => ($setup.isDetailModal(idx))
                                    }, [
                                      _createElementVNode("img", {
                                        class: _normalizeClass({ blur: item.imgPath }),
                                        src: item.imgPath ? item.imgPath : require('@/assets/common/NoImg.png')
                                      }, null, 10, _hoisted_45),
                                      _createElementVNode("button", _hoisted_46, [
                                        (item.sns === 1)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_47))
                                          : _createCommentVNode("", true),
                                        (item.sns === 2)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_48))
                                          : _createCommentVNode("", true),
                                        (item.sns === 3)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_49))
                                          : _createCommentVNode("", true),
                                        (item.sns === 4)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_50))
                                          : _createCommentVNode("", true),
                                        (item.sns === 5)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_51))
                                          : _createCommentVNode("", true),
                                        (item.sns === 6)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_52))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 8, _hoisted_44)
                                  ]),
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("p", null, [
                                      _hoisted_54,
                                      _createElementVNode("span", null, _toDisplayString(item.srIdx), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _hoisted_55,
                                      _createElementVNode("span", null, _toDisplayString(item.author ? item.author : ""), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _hoisted_56,
                                      _createElementVNode("span", null, _toDisplayString(item.messengerId ? item.messengerId : ""), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _hoisted_57,
                                      _createElementVNode("span", null, _toDisplayString(item.phoneNum ? item.phoneNum : ""), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_58, [
                                      _hoisted_59,
                                      _createElementVNode("span", null, _toDisplayString(item.keyword), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_60, [
                                    _createElementVNode("p", null, [
                                      _hoisted_61,
                                      _createElementVNode("span", {
                                        innerHTML: item.title
                                      }, null, 8, _hoisted_62)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _hoisted_63,
                                      _createElementVNode("span", {
                                        innerHTML: item.hashtag
                                      }, null, 8, _hoisted_64)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _hoisted_65,
                                      (item.siteUrl)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                                            _createElementVNode("a", {
                                              href: item.siteUrl,
                                              target: "_blank"
                                            }, _toDisplayString(item.siteUrl), 9, _hoisted_67)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("p", _hoisted_68, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "more_btn",
                                        onClick: ($event: any) => ($setup.openMoreInfo(idx))
                                      }, " 상세보기 ", 8, _hoisted_69),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["report_btn", item.isReport === 1 ? 'success' : '']),
                                        onClick: ($event: any) => ($setup.showReportForm(item))
                                      }, [
                                        (item.isReport === 1 && item.reportState === 2)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                              _createElementVNode("img", {
                                                src: require('@/assets/common/fail.png'),
                                                title: "신고에 실패했습니다."
                                              }, null, 8, _hoisted_72)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("img", {
                                          src: 
                                                                        item.isReport !== 1
                                                                            ? item.sns === 1 || item.sns === 4 || item.sns === 6
                                                                                ? require('@/assets/common/report.png')
                                                                                : require('@/assets/common/mail.png')
                                                                            : item.sns === 1 || item.sns === 4 || item.sns === 6
                                                                              ? require('@/assets/common/report_wh.png')
                                                                              : require('@/assets/common/mail_wh.png')
                                                                    ,
                                          alt: ""
                                        }, null, 8, _hoisted_73)
                                      ], 10, _hoisted_70)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("ul", null, [
                                    _createElementVNode("li", _hoisted_75, [
                                      _createElementVNode("div", null, [
                                        _hoisted_76,
                                        _withDirectives(_createElementVNode("select", {
                                          class: "select",
                                          "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                                          onChange: ($event: any) => (item.detailType = $setup.getDetailTypeFilter(item.type)[0].idx)
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.typeList, (type) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              value: type.idx
                                            }, _toDisplayString(type.name), 9, _hoisted_78))
                                          }), 256))
                                        ], 40, _hoisted_77), [
                                          [
                                            _vModelSelect,
                                            item.type,
                                            void 0,
                                            { number: true }
                                          ]
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        _hoisted_79,
                                        _createElementVNode("div", _hoisted_80, [
                                          _createElementVNode("div", _hoisted_81, [
                                            _withDirectives(_createElementVNode("select", {
                                              class: "select",
                                              "onUpdate:modelValue": ($event: any) => ((item.detailType) = $event)
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getDetailTypeFilter(item.type), (dType) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  value: dType.idx
                                                }, _toDisplayString(dType.name), 9, _hoisted_83))
                                              }), 256))
                                            ], 8, _hoisted_82), [
                                              [
                                                _vModelSelect,
                                                item.detailType,
                                                void 0,
                                                { number: true }
                                              ]
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        (item.detailType === 6)
                                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                              key: 0,
                                              type: "text",
                                              "onUpdate:modelValue": ($event: any) => ((item.detail) = $event)
                                            }, null, 8, _hoisted_84)), [
                                              [_vModelText, item.detail]
                                            ])
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("div", _hoisted_85, [
                                        _createElementVNode("div", _hoisted_86, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "deep_blue_btn",
                                            onClick: ($event: any) => ($setup.saveList(idx))
                                          }, " 저장 ", 8, _hoisted_87)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_88, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_89, [
                            _createVNode(_component_Spinner)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.list.data.length === 0 && !$setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_90, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_91, [
                            _createVNode(_component_NoResult)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.updateCheckLists(2)))
                  }, "분석완료"),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.updateCheckLists(3)))
                  }, "삭제요청완료")
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn_blue",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.multiReport()))
                  }, "신고하기"),
                  _hoisted_95,
                  _createElementVNode("div", _hoisted_96, [
                    _withDirectives(_createElementVNode("select", {
                      class: "select",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.state.typeIdx) = $event)),
                      style: {"padding-right":"40px"},
                      onChange: _cache[17] || (_cache[17] = ($event: any) => ($setup.state.detailIdx = $setup.getDetailTypeFilter($setup.state.typeIdx)[0].idx))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.typeList, (type) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: type.idx
                        }, _toDisplayString(type.name), 9, _hoisted_97))
                      }), 256))
                    ], 544), [
                      [
                        _vModelSelect,
                        $setup.state.typeIdx,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _hoisted_98,
                  _createElementVNode("div", _hoisted_99, [
                    _withDirectives(_createElementVNode("select", {
                      class: "select",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.state.detailIdx) = $event)),
                      style: {"padding-right":"40px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getDetailTypeFilter($setup.state.typeIdx), (dType) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: dType.idx
                        }, _toDisplayString(dType.name), 9, _hoisted_100))
                      }), 256))
                    ], 512), [
                      [
                        _vModelSelect,
                        $setup.state.detailIdx,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.updateState()))
                  }, "유형 일괄변경")
                ])
              ]),
              ($setup.list.data.length !== 0 && !$setup.state.isLoading)
                ? (_openBlock(), _createBlock(_component_PageBtn, {
                    key: 0,
                    currentPage: $setup.state.currentPage,
                    totalLength: $setup.state.totalLength,
                    perPage: $setup.state.perPage,
                    onOnPaging: $setup.handlePageChange
                  }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Popup, {
      show: $setup.state.isPopupOpen,
      title: $setup.modal.title,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "title", "content", "onClose"]),
    _createVNode(_component_ModalComponents, {
      show: $setup.state.isModalOpen,
      title: $setup.modal.title,
      type: $setup.modal.type,
      no: $setup.modal.cancel,
      yes: $setup.modal.confirm,
      data: $setup.modal.reportData,
      customClass: $setup.modal.customClass,
      useBtn: true,
      onClose: $setup.modalClose
    }, null, 8, ["show", "title", "type", "no", "yes", "data", "customClass", "onClose"])
  ], 64))
}